<input style="display: none" #attachments type="file" (change)="onFileChanged($event)" #fileInput multiple="true" />
<div style="float: right">
  <button mat-flat-button type="button" (click)="fileInput.click()" mat-stroked-button>Add Attachments</button>
</div>
<br />
<div class="row" style="width: 100%">
  <div class="col-md-6 col-sm-6 col-12 pr-0" *ngFor="let selected of listOfFiles; let index = index">
    <mat-card class="card-lyout"
      ><mat-card-content
        ><mat-card-title class="Card-title">
          <div class="row">
            <div class="col-md-3 col-sm-3 col-3">
              <img src="assets/images/pdf.png" width="40" />
            </div>
            <div class="col-md-7 col-sm-7 col-7 pl-1">
              <h4 class="mb-1">{{ selected }}</h4>
              <!-- <div class="file-sz">150kb</div> -->
            </div>
            <div class="col-md-2 col-sm-2 col-2">
              <i class="material-icons mt-2 attachment" (click)="removeSelectedFile(index)"> cancel </i>
            </div>
          </div>
        </mat-card-title>
        <!--ng-container--></mat-card-content
      ></mat-card
    >
  </div>
</div>
<p *ngIf="isLoading">Loading.....</p>
